var _dec, _class, _descriptor, _dec2, _dec3, _dec4, _dec5, _dec6, _class2, _class3, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import { traitClass } from "../Trait";
import mixTraits from "../mixTraits";
import EnumDimensionTraits from "./DimensionTraits";
import LegendOwnerTraits from "./FeatureInfoTraits";
import SdmxCommonTraits from "./SdmxCommonTraits";
import TableTraits from "./Table/TableTraits";
import UrlTraits from "./UrlTraits";
export let SdmxDimensionTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Position",
  description: "The position attribute specifies the position of the dimension in the data structure definition, starting at 0. This is important for making sdmx-csv requests"
}), _class = class SdmxDimensionTraits extends mixTraits(EnumDimensionTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "position", _descriptor, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "position", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
let SdmxCatalogItemTraits = (_dec2 = traitClass({
  description: "Creates one catalog item from url that points to an sdmx service.",
  example: {
    type: "sdmx-json",
    url: "https://api.data.abs.gov.au",
    dataflowId: "ABS_REGIONAL_LGA2017",
    name: "sdmx-json example",
    agencyId: "ABS",
    id: "some unique id"
  }
}), _dec3 = primitiveTrait({
  type: "string",
  name: "Dataflow ID",
  description: "SDMX Dataflow ID"
}), _dec4 = primitiveTrait({
  type: "string",
  name: "Agency ID",
  description: "SDMX Agency ID"
}), _dec5 = primitiveTrait({
  type: "string",
  name: "Unit Measure",
  description: "This string is essentially 'units' for the dataset. If a UNIT_MEASURE SDMX attribute exists in this dataflow, the default `unitMeasure` will be determined from it."
}), _dec6 = objectArrayTrait({
  type: SdmxDimensionTraits,
  name: "Dimensions",
  description: "Dimensions",
  idProperty: "id"
}), _dec2(_class2 = (_class3 = class SdmxCatalogItemTraits extends mixTraits(SdmxCommonTraits, UrlTraits, TableTraits, LegendOwnerTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "dataflowId", _descriptor2, this);
    _initializerDefineProperty(this, "agencyId", _descriptor3, this);
    _initializerDefineProperty(this, "unitMeasure", _descriptor4, this);
    _initializerDefineProperty(this, "dimensions", _descriptor5, this);
  }
}, _descriptor2 = _applyDecoratedDescriptor(_class3.prototype, "dataflowId", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, "agencyId", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, "unitMeasure", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, "dimensions", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3)) || _class2);
export { SdmxCatalogItemTraits as default };